<ideal-combobox
  #comboboxRef
  [choices]="choices()"
  [labelFn]="labelFn"
  [label]="label()"
  [placeholder]="placeholder()"
  [clearable]="true"
  [emptyMessage]="'No matching categories'"
  [name]="name()"
  (valueChange)="inputValue.set($event)"
  (matchedIndices)="matchedCategoryIndices.set($event)"
  [(selectedItem)]="selectedItem"
  [(selectedIndex)]="selectedIndex"
>
  <ng-template #selectedTemplate let-category>
    @let path = getCategoryPath(category);
    @let parentPath = getParentCategoryPath(path);
    <div>
      @if (parentPath.length > 0) {
        <div class="selected-parent-category">
          @for (cat of parentPath; track $index) {
            <span class="cat-name">{{ cat.name }}</span>
            <span class="cat-separator"> &gt; </span>
          }
        </div>
      }
      <div class="selected-category">{{ category.name }}</div>
    </div>
  </ng-template>
  <ng-template #option let-category let-selected="selected">
    <div
      class="cat-item"
      [class.has-input]="hasInputValue()"
      [class.selected]="selected"
      [class.child-selected]="getChildCategorySelected(category)"
      [class.has-matched-descendants]="hasMatchingDescendants(category)"
      [class.is-matched]="isMatched(category)"
    >
      <div [attr.indent]="category.level"></div>
      <div class="name">{{ category.name }}</div>
    </div>
  </ng-template>
</ideal-combobox>
